import React from "react"

import Button from "legacy/components/shared/Button"
import { Element, Text } from "legacy/components/shared/base"
import { Maybe } from "types/Maybe"
import {
  CurvedTextItemType,
  CurvedTextPrimaryType,
} from "types/shared-components"

interface OwnProps {
  bodyText: Maybe<Array<Maybe<CurvedTextItemType>>>
  primary: Maybe<CurvedTextPrimaryType>
}

export type BodyTextProps = OwnProps

const BodyText: React.FC<BodyTextProps> = ({
  bodyText,
  primary,
}): React.ReactElement | null => {
  if (!bodyText) return null

  return (
    <Element
      mt={["20", "20", "0"]}
      pl={["0", "0", "0", "10%"]}
      textAlign={["center", "center", "center", "left"]}
      width={["100%", "100%", "100%", "50%"]}
    >
      {bodyText?.map((item, index) => {
        return (
          <Text
            as="p"
            fontSize={["17", "text.body"]}
            key={`body_text_${index}`}
            lineHeight={["28px", "1.8"]}
            mb={index < bodyText?.length - 1 ? ["10", "20"] : 0}
          >
            {item?.body_text}
          </Text>
        )
      })}
      {primary?.button_text && primary?.button_url?.url ? (
        <Button
          as="a"
          display="inline-block"
          fontSize={["16", "text.button"]}
          href={primary.button_url.url}
          mt={["50", "60", "60"]}
          variant={primary.button_color === "aqua" ? "primaryAqua" : "primary"}
        >
          {primary.button_text}
        </Button>
      ) : null}
    </Element>
  )
}

export default BodyText
